
import { Component, Vue,Prop } from 'vue-property-decorator';

import ObjectTableVue from './ObjectTable.vue';
import { CtxStore } from './interface/CtxStore';
import { IParam, typeParam } from '../../../server/src/ai/interface/IParam';
import { DragManager, typeMoveCtx, typeSelectCtx, typeMoveParam, typeMoveObj, typeCtxParam, typeDatasourceParam } from "./DragManager";
import Bus from "@/lib/Bus";

const bus: Bus = new Bus().getBus();
import {List} from "./Preact"
import { h, render } from 'preact';
import { IFolder } from 'server/src/ai/interface/IFolder';
import yaml from 'js-yaml';
import { IDatasource} from "../../../server/src/ai/interface/IDatasource";
import { remove_table_prefix } from "../../../server/src/ai/interface/DatasourceLib";
const sample_yaml=`
klient:
  imię: Jan
  nazwisko: Brzęczyszczykiewicz
  wiek: 30
  produkty:
    - produkt: cebula
    - produkt: pomidor
  adres:
    ulica: ul. Klonowa
    numer: 10
`;


@Component({components: {  ObjectTableVue, ContextVue} })

export default class ContextVue extends Vue {
  @Prop(Object)   folder: IFolder | undefined
  @Prop(Object)   context: any

  ctx: { [key:string] : any} | undefined
  fold:any

  dm=DragManager.getInstance()
  param_name:string=""
  key=0;
  add_expression_key=0;
  add_expression:string=""
  

  data = [
      { id: 1, name: 'Item 1', price: '$10' },
      { id: 2, name: 'Item 2', price: '$20' },
      { id: 3, name: 'Item 3', price: '$30' }
  ];
 


  async mounted() {

    this.refresh()
  }

  /*    
    const createListComponentStr = `
      function createListComponent(list, documentId, onSelect) {
       const container = document.getElementById(documentId);
    
    // Create table element
    const table = document.createElement('table');
    
    // Create table header
    const headerRow = document.createElement('tr');
    for (const key of Object.keys(list[0])) {
        const th = document.createElement('th');
        th.textContent = key;
        headerRow.appendChild(th);
    }
    table.appendChild(headerRow);
    
    // Create table rows
    list.forEach(item => {
        const row = document.createElement('tr');
        for (const key of Object.keys(item)) {
            const cell = document.createElement('td');
            cell.textContent = item[key];
            row.appendChild(cell);
        }
        row.addEventListener('click', () => onSelect(item));
        table.appendChild(row);
    });
    
    container.appendChild(table);
      }
    `;
*/


  installComponent(code:string) {
    console.log(code)


    // Sample data
    const data = [
      { id: 1, name: 'John', age: 30 },
      { id: 2, name: 'Alice', age: 25 },
      { id: 3, name: 'Bob', age: 35 }
    ];

    // Create a container element
    const container = document.createElement('div');
    container.id = 'container1';
    document.getElementById('container')?.appendChild(container);

    // Render the List component
    //render(  h(List, { data: data, handleClick: this.handleEvent }),   container    );    
    /*
        this.$nextTick(() => {
          try {
          //const pokaż_listę = eval(`(${code})`);
          pokaż_listę(this.ctx, 'container', this.handleEvent);  
          } catch (err) {
            console.log(err)
          }
        });
        */
  }
  
async handleEvent(item: any) {
    console.log('Event:', item);
}


async refresh() {
  this.ctx = this.context ? this.context : {}
  this.fold = this.folder
  if (this.ctx && this.fold) {
    this.key++
    return
  }
}

 
isString(variable: any): boolean {
  return typeof variable === 'string';
}



async add_param(event: MouseEvent) {
  if (!this.ctx) return;


  event.stopPropagation()
  let max=1;
  const key=this.param_name
  if (!this.param_name) { alert("Wpisz nazwę parametru."); return;}
  const pp=Object.keys(this.ctx.params)
  for (const p of pp) {
    if (key==p) { alert("Parametr już istnieje."); return;}
  }

  const p:IParam = { key:key, value:"", type: typeParam, src_key:"", src_id:"" }
  
  this.ctx.params[key] = p
  console.log(this.ctx.params)
  if (this.ctx) {
    await CtxStore.save(this.ctx)
  }
  this.key++
}

async handleDragStart(key:string, set: IParam, event:MouseEvent) {

    event.stopPropagation();
    event.preventDefault();
    if (!this.ctx) return;

    this.dm.reset(typeMoveCtx)
    this.dm.reset(typeMoveParam)
    this.dm.reset(typeMoveObj)
    console.log("handleDragStart CtxParamsVue", key, this.ctx.params[key])
    this.dm.set(this.ctx.params[key], typeMoveParam)
    this.dm.show_tooltip(key+':'+this.ctx.params[key].value, event.clientX-10, event.clientY+10 )

  }

  

  async handleAssign(event: any) {
    event.stopPropagation();
    console.log('TEST0')
    if (!this.ctx) return;
    
    let type=""
    if (this.dm.get(typeMoveParam)) type = typeMoveParam
    if (this.dm.get(typeMoveObj)) type = typeMoveObj
    if (this.dm.get(typeCtxParam)) type = typeCtxParam
    if (this.dm.get(typeCtxParam)) type = typeCtxParam
    if (this.dm.get(typeDatasourceParam)) {
      type=typeDatasourceParam

      const ds:IDatasource = this.dm.get(typeDatasourceParam )
      let txt=remove_table_prefix(ds.name)+":\n"
      for (let f of ds.fields) {
        if (f.type=="Number") txt+="    "+f.name+": 0\n"
        if (f.type=="String") txt+="    "+f.name+': ""\n'
        if (f.type=="Date")   txt+="    "+f.name+': "2024-01-01"\n'
      }
      this.add_expression = txt

    } else {

      const s = this.dm.get(type)
      if (!s) return
      event.preventDefault();

      console.log('TEST2'+s)

      if (s && s.value) {
        this.add_expression = s.key+":"+s.value
      }
      }
    this.dm.reset(type)
    this.dm.hide_tooltip()
    this.add_expression_key++
  }
  
  async handleDrop(key:string, value:any,  event: any) {
    console.log("******************* handleDrop", key, event, this.ctx)
    event.preventDefault();
    event.stopPropagation();

    if (!this.ctx) return;
    
    let type=""
    if (this.dm.get(typeMoveParam)) type = typeMoveParam
    if (this.dm.get(typeMoveObj)) type = typeMoveObj
    if (this.dm.get(typeCtxParam)) type = typeCtxParam

  

    const s = this.dm.get(type)
    if (!s) return

    console.log(s)

    if (s && s.value) {
      this.ctx[key] = s.value
    }
  
    this.dm.reset(type)
    this.dm.hide_tooltip()
    await this.chg()
    
   }


  copyToNotepad(value:string) {
    if (!this.ctx) return;
    const valueToCopy = JSON.stringify(value);

    // Create a temporary textarea element to facilitate copying to clipboard
    const textarea = document.createElement('textarea');
    textarea.value = valueToCopy;
    document.body.appendChild(textarea);

    // Select the value within the textarea
    textarea.select();
    textarea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to clipboard
    document.execCommand('copy');

    // Remove the temporary textarea
    document.body.removeChild(textarea);

    alert('Skopiowano do notatnika.');
  }

  get_source_name(p:any) {
    return ''
  }

  ignore_mouse(event:MouseEvent) {
    console.log("this.ignore_mousedown")
    event.stopPropagation()
    //event.preventDefault()
  }


  add() {
    
    if (!this.ctx) return;

    if (this.dm.get(typeDatasourceParam)) {

      const ds:IDatasource = this.dm.get(typeDatasourceParam )
      const title=ds.name.replace("ut_jm_ai_","")
      this.ctx[title] = ds
      this.dm.hide_tooltip()
      this.dm.reset(typeDatasourceParam )

    } else {
      let s = this.add_expression
      //let s=sample_yaml;
      if (!s) { alert("Zdefiniuj przypisanie.");   return;   }
      if (!s.trim()) { alert("Zdefiniuj przypisanie.");   return;   }
      let obj:any={}
      if (s.includes("\n") && s.includes(":")) {
        try {
          obj =  yaml.load(s);      
        } catch (err) {
          console.log(err)
        }
      } else {
        let pre  = s.split(':')[0]
        if (!pre) {  alert("Zdefiniuj przypisanie."); return;  }

        pre = pre.trim().replace(/ /g, "_");

        let post = s.split(':')[1]
        if (!post) post = '""'

        s = pre+": "+post
        obj[pre] =  post
        this.add_expression = s
      }

      for (let k in obj) {
        this.ctx[k] = obj[k]
        console.log(k,obj[k]);
      }
    }
    this.chg()
  }


 async createView() {
  /*
    if (!this.add_expression) { 
      alert("wpisz zadanie dla widoku")
      return;
    }
    const use_bots:string[] = []
    //Napisz funkcję pokaż_listę pokazującą listę {lista_handlowców} w tabeli. Obsłuż zdarzenie: selekcja_wiersza
    //Napisz funkcję edytuj_obiekt pokazującą wszystkie właściwości obiektu {obiekt} z możliwością edycji. Obsłuż zdarzenie: edycja_wartości
    const new_view:IBot = await bus.api("/api/ai/createView", { instrukcja:this.add_expression, use_bots: use_bots, parent_id:this.folder_id } );
    this.installComponent(new_view.function_code)
    */

    this.installComponent('')
    //console.log(new_view)
    //await this.refresh()
  }
 
  async delParam(key:string) {
    if (!this.ctx) return;
    delete this.ctx[key]
    await this.chg()
  }

  async chg() {
    this.$emit("ctx_changed", this.folder?.ctx)
    this.key++
  }


 resizeTextarea(id: any, expand:boolean, event: MouseEvent) {
  console.log('resizeTextarea', expand)
  event.stopPropagation()

  const textarea = document.getElementById(id); // Select all textareas with the specified class
  

  if (!expand) {
    event.preventDefault()
    if ((event.button === 2)) {
      const v=textarea?(<any>textarea).value:""
      //if (typeof v == "number" || typeof v == "string" ) {
      this.dm.set({text: v, key:id, value: v}, typeCtxParam )
      this.dm.show_tooltip(id+ (textarea?': '+v.toString():""), event.clientX-10, event.clientY+10 )
      this.copyToClipboard(v.toString())
      //}
    } else {
      this.dm.hide_tooltip()    
      this.dm.reset(typeCtxParam )
    }
  } 
  
  else {
    this.dm.hide_tooltip()    
    this.dm.reset(typeCtxParam )
  }
  if (!textarea) return;
  (<any>textarea).style.height = 'auto'; // Reset the height to auto to calculate the actual height
  if (expand) {
  (<any>textarea).style.height = 600 + 'px'; // Set the height to the scroll height
  } else {
  (<any>textarea).style.height = 50+'px';
  }
  }

async handleMouseMove(event: MouseEvent) {
    
    if (this.dm.get(typeCtxParam)  ) {
      this.dm.move_tooltip( event.clientX+30, event.clientY+10 )
      return;
    }
}

  copyToClipboard(text:string) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      //alert('Skopiowano tekst do notatnika!');
    }


  async table_insert(ds: IDatasource, event: MouseEvent) {
    console.log(ds)
    const ret:any= await bus.api("/api/ai/datasource/table_op", {user: bus.get_user(), op:"INSERT",ds:ds} );
    if (ret.errors.length) { alert(ret.errors.join('\n')); return; }
    if (!ret.ret) { alert("Wynik jest pusty. "+ret.errors.join('\n')); return; }
    ds.obj['_id'] = ret.ret.obj['_id']
    console.log(ret)
    this.key++
  }

  async table_del(ds: IDatasource, event: MouseEvent) {
    console.log(ds)
    const ret:any= await bus.api("/api/ai/datasource/table_op", {user: bus.get_user(), op:"DELETE",ds:ds} );
    if (ret.errors.length) { alert(ret.errors.join('\n')); return; }
    if (!ret.ret) { alert("Wystąpił problem z usunięciem wiersza. "+ret.errors.join('\n')); return; }
    else {
      for (let f of ds.fields) {
        if (f.type=="String") ds.obj[f.name] = ""
        if (f.type=="Number") ds.obj[f.name] = 0
        if (f.type=="Date") ds.obj[f.name] = "2024-01-01"
      }
      await this.chg()
    }
  }

  async table_find(ds: IDatasource, event: MouseEvent) {
    console.log(ds)
    const ret:any= await bus.api("/api/ai/datasource/table_op", {user: bus.get_user(), op:"FIND",ds:ds} );
    if (ret.errors.length) { alert(ret.errors.join('\n')); return; }
    if (!ret.ret) { alert("Brak wierszy. "+ret.errors.join('\n')); return; }
    else {
      ds.table=ret.ret;
      this.key++
    }
  }


}
